import { Static, Object, String } from '@sinclair/typebox';

import { StringEnumSchema } from '../../../utils/types';
import { ContentTypes } from '../../contentful/ContentfulInterface';

export type ContentfulDataRequestParams = Static<typeof ContentfulDataRequestParams>;
export const ContentfulDataRequestParams = Object({
  contentfulId: String(),
  contentType: StringEnumSchema(ContentTypes),
});
